// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"styles-m__cookieConsent__3ixt3","btn-acc":"styles-m__btn-acc__1Im30","text-capitalize":"styles-m__text-capitalize__20o5L"};